<!--
 * @Author: OnismYY 2848335733@qq.com
 * @LastEditTime: 2024-11-27 16:25:44
 * @FilePath: \h5-front\src\components\common\ali-icon-font.vue
 * @Description: 阿里巴巴矢量图标   请复制Symbol类型的图标名称，只需填入#icon-  后面的名称即可
-->
<template>
  <div>
    <svg
      class="icon"
      :style="{ width: size, height: size, fill: color }"
      aria-hidden="true"
    >
      <use :xlink:href="`#icon-${name}`"></use>
    </svg>
  </div>
</template>
<script setup>
defineProps({
  name: { type: String, required: true }, // 图标名称
  size: { type: String, default: '1em' }, // 图标大小
  color: { type: String, default: '' } // 图标颜色
})
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: -0.15em;
}
</style>
